import React from "react";

import styles from "../assets/Header.module.css";
import { useSiteMetadata } from "../hooks";

export const Header: React.FC = () => {
  const { avatar, title, description, helpText } = useSiteMetadata();

  if (!title && !description) {
    return null;
  }

  return (
    <header>
      <section className={styles.header}>
        {avatar && <img className={styles.avatar} src={avatar} alt={title} title={description} />}
        <h1>{title}</h1>
      </section>
      <p>{description}</p>
      {helpText && <small>{helpText}</small>}
    </header>
  );
};
